import { render } from "./StorageSimpleWidget.vue?vue&type=template&id=9ca10da4"
import script from "./StorageSimpleWidget.vue?vue&type=script&lang=js"
export * from "./StorageSimpleWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__